import type {CompanyFiltersType, CompanyProfileType} from '~/utils/types/account/companies/types'

export const initCompanyFilters = (): CompanyFiltersType => ({
    type: null,
    contractGroupId: null,
    rangeType: null,
    rangeFrom: null,
    rangeTo: null,
    countryId: null,
    name: null,
    reservationNumberFrom: null,
    reservationNumberTo: null,
    cityId: null,
    managerId: null,
    organizationBalanceFrom: null,
    organizationBalanceTo: null,
    companyCodeOrAlias: null,
    stage: null,
    industry: null,
    priorityLevel: null,
    companySize: null,
    active: true,
    phone: null,
})

export const initCompanyProfile = (): CompanyProfileType => ({
    active: true,
    name: {},
    type: null,
    alias: null,
    companyCode: null,
    countryId: null,
    cityId: null,
    region: {},
    address: {},
    postalCode: null,
    postAddress: {},
    contactPerson: {
        prefix: null,
        firstName: {},
        middleName: {},
        lastName: {},
    },
    phones: ['', '', ''],
    fax: null,
    url: null,
    emails: ['', '', ''],
    officialCompanyName: {},
    externalCode: null,
    taxRegistrationReason: null,
    vatNumber: null,
    iataNumber: null,
    docexNumber: null,
    consortium: null,
    subconsortium: null,
    comments: {},
    language: null,
    logo: null,
    stage: null,
    priorityLevel: null,
    industry: null,
    companySize: null,
    externalId: null,
    id: null,
    signature: null,
})
